import script from "./SearchArtworkPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchArtworkPage.vue?vue&type=script&setup=true&lang=js"

import "./SearchArtworkPage.vue?vue&type=style&index=0&id=f23fd78a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f23fd78a"]])

export default __exports__